import { Controller } from "@hotwired/stimulus";
import { put } from "@rails/request.js";

export default class extends Controller {
  static outlets = ["polaris-select", "polaris-button"];
  static targets = ["image", "degreeSelector"];
  static values = {
    imageRotateUrl: String,
  };

  previewRotation(event) {
    const degrees = event.target.value;

    if (!degrees) {
      this.resetRotation();
      this.#disableButtonsWithoutLoader();
      return;
    }

    this.#enableButtons();
    this.#rotatePreviewImage(degrees);
  }

  async rotate() {
    this.#disableButtons();

    await put(this.imageRotateUrlValue, {
      responseKind: "turbo-stream",
      body: JSON.stringify({
        rotate_degrees: this.degreeSelectorTarget.value,
      }),
    });

    this.#resetDegreeSelector();
    this.#enableButtons();
    this.#disableButtonsWithoutLoader();
  }

  resetRotation() {
    if (this.hasImageTarget) {
      this.#rotatePreviewImage(0);
    }

    this.#resetDegreeSelector();
    this.#disableButtonsWithoutLoader();
  }

  #disableButtonsWithoutLoader() {
    this.polarisButtonOutlets.forEach((outlet) => {
      if (this.element.contains(outlet.element)) {
        outlet.disableWithoutLoader();
      }
    });
  }

  #disableButtons() {
    this.polarisButtonOutlets.forEach((outlet) => {
      if (this.element.contains(outlet.element)) {
        outlet.disable();
      }
    });
  }

  #enableButtons() {
    this.polarisButtonOutlets.forEach((outlet) => {
      if (this.element.contains(outlet.element)) {
        outlet.enable();
      }
    });
  }

  #resetDegreeSelector() {
    this.degreeSelectorTarget.value = "";
    this.polarisSelectOutlets.forEach((outlet) => {
      if (this.element.contains(outlet.element)) {
        outlet.update();
      }
    });
  }

  #rotatePreviewImage(degrees) {
    this.imageTarget.style.transition = "transform 0.5s ease";
    this.imageTarget.style.transform = `rotate(${degrees}deg)`;
  }
}
